import React from "react";
import styled from "styled-components";

const Wrapper = styled.div``;
const Container = styled.div`
  font-size: 12px;
  padding: 14px 0px;
  border-bottom: 1px solid #b4b4b4;
  align-items: center;
`;
const Flex = styled.div`
  display: flex;
    justify-content: space-between;
`;
const Option = styled.div`
  display: flex;
  align-items: center;
  input[type="radio"] {
    border: black;
  }
  span {
    margin-left: 5px;
  }
`;
const Info = styled.div`
  color: #cac4c4;
  margin: 4px 16px;
`;
function RadioButton() {
  return (
    <Wrapper>
      <Container>
        <Flex>
          <Option>
            <input
              type="radio"
              id="option1"
              name="shippingMethod"
              value="Option1"
            />
            <span htmlFor="option1">UPS Standard</span>
          </Option>
          <span>30 USD</span>
        </Flex>
        <Info>Delivery time UPS Standard 2-5 days</Info>
      </Container>
    </Wrapper>
  );
}

export default RadioButton;